const formula = [
    {
        "value": "SUM",
        "label": "SUM"
    }
].sort((a, b) => {
    return a.label.localeCompare(b.label);
});

export default formula;